export default __webpack_public_path__ + "static/media/048-gorilla.a0058ddc.svg";